import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Save } from "lucide-react";

const DAYS = [["mon","Monday"],["tue","Tuesday"],["wed","Wednesday"],["thu","Thursday"],["fri","Friday"],["sat","Saturday"],["sun","Sunday"]];
const TIMES = ["08:00","08:30","09:00","09:30","10:00","10:30","11:00","11:30","12:00","13:00","13:30","14:00","14:30","15:00","15:30","16:00","16:30","17:00","17:30","18:00"];

export default function DoctorAvailability() {
  const [slots, setSlots] = useState({});
  const [buffer, setBuffer] = useState(5);
  const [maxDaily, setMaxDaily] = useState(12);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/doctor/me").then(async r => {
      const a = await api.get(`/doctors/${r.data.user_id}`);
      const av = a.data.availability;
      if (av) { setSlots(av.weekly_slots || {}); setBuffer(av.buffer_minutes || 5); setMaxDaily(av.max_daily || 12); }
    });
  }, []);

  const toggle = (day, t) => {
    const cur = new Set(slots[day] || []);
    if (cur.has(t)) cur.delete(t); else cur.add(t);
    setSlots({ ...slots, [day]: [...cur].sort() });
  };

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/doctor/availability", { weekly_slots: slots, buffer_minutes: Number(buffer), max_daily: Number(maxDaily) });
      toast.success("Availability saved");
    } catch { toast.error("Could not save"); }
    finally { setSaving(false); }
  };

  return (
    <div className="space-y-6">
      <div><div className="cm-eyebrow mb-2">Availability</div><h1 className="cm-h2">Set your weekly slots</h1></div>

      <div className="cm-card grid sm:grid-cols-2 gap-4">
        <div><label className="cm-label">Buffer between appointments (minutes)</label><input className="cm-input" type="number" min="0" value={buffer} onChange={e=>setBuffer(e.target.value)} data-testid="avail-buffer"/></div>
        <div><label className="cm-label">Max appointments per day</label><input className="cm-input" type="number" min="1" value={maxDaily} onChange={e=>setMaxDaily(e.target.value)} data-testid="avail-max"/></div>
      </div>

      <div className="cm-card">
        <p className="text-sm text-[#475569] mb-4">Click times to add or remove them from your weekly recurring availability.</p>
        {DAYS.map(([k, label]) => (
          <div key={k} className="mb-4">
            <div className="font-semibold text-[#1a2b4a] mb-2">{label}</div>
            <div className="flex flex-wrap gap-2">
              {TIMES.map(t => {
                const on = (slots[k] || []).includes(t);
                return (
                  <button key={t} onClick={()=>toggle(k,t)} className={`text-xs rounded-full px-3 py-1.5 border transition ${on ? "bg-[#4a90d9] text-white border-[#4a90d9]" : "bg-white text-[#475569] border-[#e2e8f0] hover:border-[#4a90d9]"}`} data-testid={`avail-${k}-${t}`}>{t}</button>
                );
              })}
            </div>
          </div>
        ))}
      </div>

      <button className="cm-btn-primary" onClick={save} disabled={saving} data-testid="avail-save"><Save size={14}/> {saving?"Saving…":"Save availability"}</button>
    </div>
  );
}
